// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"b5fa3e0d","353":"1e8fb779"}[chunkId] + ".js";
};